import {
  useServicedCommunities,
} from '@src/modules/performance/context/reports-api-hooks';

import { Link, Text } from '@chakra-ui/react';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Public Transport Communities',
  content: [
    {
      title: 'Serviced communities included',
      description:
  <Text fontSize="inherit" mb={2}>
    A list of the serviced communities included in the results reported within the Public Transport section. The serviced communities applicable to each RCA has been determined by Road Efficiency Group Te Ringa Maimoa based on the description of the community.
  </Text>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from
    {' '}
    <Link href="https://www.nzta.govt.nz/planning-and-investment/learning-and-resources/transport-data/data-and-tools/" isExternal>NZTA Data and Tools, use - public transport</Link>
  </Text>,
    },
  ],
};

function PublicTransportCommunities() {
  const { data, isLoading } = useServicedCommunities();

  return (
    <ReportSection
      title="Public Transport Communities"
      isLoading={isLoading}
      informationSource={informationSource}
      lockYear={data?.[0]?.LockYear}
    >
      <Text mb={4} fontSize="xs">Serviced communities included:</Text>
      {data?.map((community) => (
        <Text key={community.ServicedCommunity} fontSize="sm" fontWeight="bold">{community.ServicedCommunity}</Text>
      ))}
      {data?.some((x) => !x.ServicedCommunity) && (
        <Text fontSize="sm" fontWeight="bold">None listed</Text>
      )}
    </ReportSection>
  );
}

export default PublicTransportCommunities;
